import React from 'react';
import { Spin } from 'antd';
import { isEqual, isEmpty } from 'lodash';
import { WeaTools, WeaErrorPage ,WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
const { ls } = WeaTools;
import EHeader from '../common/EHeader';
import FooterMore from "../common/FooterMore";
import { formatDate, NoRightCom } from '../../util/common';
import CalendarStyle from './CalendarStyle/'

import './style.css';
//元素组件
class MyCalendar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            edata: null,
            refresh: false,
            isShowLunar: '0',
            stylevalue:'',
            defaultView:'',
        }
        this.handleEData = this.handleEData.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }
    handleDelete(){
        this.setState({
            edata: null,
        });
        ls.set('edata-'+this.props.config.params.eid, null);
    }
    handleRefresh(){
        this.setState({
            refresh: true,
        });
        this.handleEData(this.props.config.params);
    }
    handleEData(params){
        const { eid, api } = params;
        WeaTools.callApi(api || '/api/workplan/calendar/MyCalendar', 'POST', {viewType: '3', selectDate: formatDate(new Date(), "yyyy-MM-dd")}).then(data=> {
            ls.set('edata-'+eid, data);
            let dataNew={};
            dataNew = data
            WeaTools.callApi(api || '/api/portal/element/mycalendar', 'POST', {...params}).then(data=> {
                const { esetting={} ,stylevalue=''} = data;
                const { isShowLunarDatas='0' } = esetting;
                dataNew.isShowLunarDatas = isShowLunarDatas;
                this.setState({
                    edata: dataNew,
                    refresh: false,
                    isShowLunar: isShowLunarDatas,
                    stylevalue:stylevalue,
                    defaultView:data.defaultView,
                });
            });
        });
    }
    componentDidMount(){
        const { config = {} } = this.props;
        const { params = {} } = config;
        const { eid } = params;
        const edata = ls.getJSONObj(`edata-${eid}`);
        if (config.islsdata && edata) {
            this.setState({ edata });
        } else {
            this.handleEData(params);
        }
    }
    componentWillReceiveProps(nextProps){
        const { item, params, isHasRight } = this.props.config;
        const config = { item, params, isHasRight };
        const _config = { 
            item: nextProps.config.item, 
            params: nextProps.config.params, 
            isHasRight: nextProps.config.isHasRight,
        };
        if(!isEqual(config, _config) || nextProps.config.isRender){
            this.handleEData(nextProps.config.params);
        }
    }
    shouldComponentUpdate(nextProps, nextState){
        const { item, params, isHasRight } = this.props.config;
        const config = { item, params, isHasRight };
        const _config = { 
            item: nextProps.config.item, 
            params: nextProps.config.params, 
            isHasRight: nextProps.config.isHasRight,
        };
        return !isEqual(this.state, nextState) || !isEqual(config, _config)
    }
    render() {
        const { edata, refresh, isShowLunar,stylevalue,defaultView } = this.state;
        const { config, fontSizeMp } = this.props;
        if(!config || !edata) return <div/>;
        const { isHasRight, item, params, layoutid } = config;
        const { eid, ebaseid, content, header, contentview, style } = item;
        const { style: style1= {} } = contentview;
        let EContentHtml = <div/>;
        if (isHasRight) {
            if(!isEmpty(edata)&&defaultView!=''){
                EContentHtml=<CalendarStyle stylevalue={stylevalue} {...this.props} eid={eid} data={edata} defaultView={defaultView} isShowLunar={isShowLunar} isShowLunarDatas={edata.isShowLunarDatas} hpid={params.hpid} styleid={params.styleid} layoutid={layoutid} subCompanyId={params.subCompanyId}/>               
            }
        } else {
            EContentHtml = <NoRightCom ecId={`${this && this.props && this.props.ecId || ''}_NoRightCom@ivpj2o`}/>
        }
        return <div className="item" 
                    style={style}
                    id={`item_${eid}`} 
                    data-eid={eid} data-ebaseid={ebaseid} 
                    data-needRefresh={item.needRefresh} 
                    data-cornerTop={item.cornerTop} 
                    data-cornerTopRadian={item.cornerTopRadian}
                    data-cornerBottom={item.cornerBottom} 
                    data-cornerBottomRadian={item.cornerBottomRadian}>
                    <EHeader ecId={`${this && this.props && this.props.ecId || ''}_EHeader@99ch3d`} config={config} handleRefresh={this.handleRefresh} handleDelete={this.handleDelete} fontSizeMp={fontSizeMp}/>
                    <div className="setting" id={`setting_${eid}`}></div>
                    <div className="content" id={`content_${eid}`} style={{width:'auto',_width:'100%'}}>
                        <div className="content_view" id={`content_view_id_${eid}`} style={{height: style1.height}}>
                            <Spin ecId={`${this && this.props && this.props.ecId || ''}_Spin@m91zp4`} spinning={refresh}>{EContentHtml}</Spin>
                        </div>
                        <div style = {{textAlign:'right'}} id={`footer_${eid}`}><FooterMore ecId={`${this && this.props && this.props.ecId || ''}_FooterMore@vmnt5o`} config={this.props.config}/></div>
                    </div>
            </div>;
    }
}
class MyErrorHandler extends React.Component {
    render() {
        const hasErrorMsg = this.props.error && this.props.error !== "";
            return ( <WeaErrorPage ecId={`${this && this.props && this.props.ecId || ''}_WeaErrorPage@7wsq3o`} msg = { hasErrorMsg ? this.props.error : getLabel(385218,"对不起，该页面异常，请联系管理员！") }/>
        );
    }
}
MyCalendar = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(MyCalendar);
export default MyCalendar;






// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/mycalendar/index.js